import React from 'react';
import { motion } from 'framer-motion';

const TermsOfService = () => {
  return (
    <div className="legal-page">
      <div className="container">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <h1>Terms of Service</h1>
          <p className="last-updated">Last updated: January 2024</p>

          <section>
            <h2>1. Acceptance of Terms</h2>
            <p>By accessing and using AuVSys services, you accept and agree to be bound by the terms and provision of this agreement.</p>
          </section>

          <section>
            <h2>2. Services Description</h2>
            <p>AuVSys provides technology consulting, cloud services, AI/ML solutions, cybersecurity, and digital transformation services to enterprise clients globally.</p>
          </section>

          <section>
            <h2>3. User Responsibilities</h2>
            <ul>
              <li>Provide accurate and complete information</li>
              <li>Maintain the confidentiality of account credentials</li>
              <li>Use services in compliance with applicable laws</li>
              <li>Respect intellectual property rights</li>
            </ul>
          </section>

          <section>
            <h2>4. Intellectual Property</h2>
            <p>All content, trademarks, and intellectual property on this website are owned by AuVSys or our licensors.</p>
          </section>

          <section>
            <h2>5. Limitation of Liability</h2>
            <p>AuVSys shall not be liable for any indirect, incidental, special, consequential, or punitive damages.</p>
          </section>

          <section>
            <h2>6. Contact Information</h2>
            <p>For questions about these Terms of Service, contact us at:</p>
            <p>Email: legal@auvsys.com<br />
            Phone: +60 XX XXX XXXX</p>
          </section>
        </motion.div>
      </div>
    </div>
  );
};

export default TermsOfService;